<template>
  <div class="article-wrapper" :class="{ 'has-mobile-toolbar': mobileToolbar }">
    <!-- 中间文章信息 -->
    <el-card class="article" shadow="never">
      <el-skeleton v-if="!fetchSuccess" />
      <div style="min-height: 70px" v-else>
        <h1 class="article-title">
          {{ article.title }}
        </h1>
        <!-- 文章内容（纯文本渲染，样式里用 white-space: pre-wrap 保留换行） -->
        <article class="content" :style="style">{{ article.content }}</article>
        <ImgContent :avatar-list="article.avatarList"></ImgContent>

        <!-- 投票：图片之后、发布地址之前。这个组件同时被弹窗和 /article/:id 路由页复用，
             改这一处就覆盖两个入口 -->
        <PollView
          v-if="article.poll"
          :poll="article.poll"
          :article-id="articleId"
          @voted="onPollVoted"
        />

        <!-- 发布地址 -->
        <div class="publish-location" v-if="article.ipSource">
          <span>发布于 {{ article.ipSource }}</span>
        </div>

        <!-- 审核状态：只有作者预览未过审帖子时才出现 -->
        <div
          v-if="auditBadge"
          class="audit-banner"
          :class="'audit-banner--' + auditBadge.key"
        >
          {{ auditBadge.tip }}
        </div>

      </div>

      <!-- 举报弹窗 -->
      <ReportDialog
        :visible.sync="reportDialogVisible"
        :articleId="articleId"
      />

      <div class="item">
        <!-- 移动端由外层的底部操作条承担点赞/评论/收藏，这里不重复一遍 -->
        <template v-if="!mobileToolbar">
          <span class="text textItem" @click="like(article)">
            <svg-icon
              :icon-class="article.isLike ? 'hearted' : 'heart'"
            />
            <span>{{
              formatViews(article.likeCount == null ? 0 : article.likeCount)
            }}</span>
          </span>
          <span class="text textItem">
            <svg-icon icon-class="pingluncount" style="vertical-align: -3px" />
            {{ formatViews(article.commentCount ?? 0) }}
          </span>
          <span class="text textItem" @click="handleCollect(article)">
            <svg-icon
              :icon-class="article.isCollect ? 'starred' : 'star'"
            />
            <span>
              {{ formatViews(article.collectCount ?? 0) }}
            </span>
          </span>
        </template>
<!--        <span class="text textItem">-->
<!--          <svg-icon icon-class="fenxiangcount" />-->
<!--          <span class="nickname">分享</span>-->
<!--        </span>-->
        <span class="item-extra">
          <span class="nickname">浏览量</span>
          <span style="margin-left: 8px">{{ formatViews(article.quantity ?? 1) }}</span>
          <!-- 更多操作 ··· -->
          <el-popover
            placement="bottom-end"
            trigger="click"
            v-model="moreMenuVisible"
            popper-class="more-actions-popover"
          >
            <div class="more-menu">
              <div class="more-menu-item" :class="{ active: isRecommend }" @click="handleRecommend">
                <svg-icon :icon-class="isRecommend ? 'dianzaned' : 'dianzancount'" class="menu-svg" />
                <span>{{ isRecommend ? '已推荐' : '推荐' }}</span>
              </div>
              <div class="more-menu-item" :class="{ active: isNotInterested }" @click="handleNotInterested">
                <i :class="isNotInterested ? 'el-icon-remove' : 'el-icon-remove-outline'" class="menu-i"></i>
                <span>{{ isNotInterested ? '已标记不感兴趣' : '不感兴趣' }}</span>
              </div>
              <div class="more-menu-item" @click="handleReport">
                <i class="el-icon-warning-outline menu-i"></i>
                <span>举报内容</span>
              </div>
            </div>
            <div class="more-btn hand-style" slot="reference">
              <svg-icon icon-class="more" />
            </div>
          </el-popover>
        </span>
      </div>

      <div class="tag-share">
        <div>
          <a
            class="tagBtn hand-style"
            v-for="item in article.tagList"
            :key="item.id"
            @click="handleClike(item.id, '/tags')"
          >
            <span type="success">
              <i class="el-icon-collection-tag"></i> {{ item.name }}
            </span>
          </a>
        </div>
        <!-- 分享 -->
      </div>

      <!-- 评论 -->
      <div class="comment-main" id="comment" ref="commentSection">
        <div class="comment-divider"></div>
        <div class="title">
          全部评论
          <span class="title-tip">发表评论,来抢沙发</span>
        </div>
        <Comment
          ref="commentRef"
          :articleInfo="article"
          :commentId="commentId"
          @comment-added="handleCommentAdded"
          @comment-removed="handleCommentRemoved"
        />
      </div>
    </el-card>
  </div>
</template>
<script>
import { articleFetch } from '@/api'
import articleMixins from '@/mixins/articleMixinx'
import Comment from '@/components/comment/index.vue'
// import imagePreview from '@/components/imagePreview'
import ImgContent from '@/components/imgContent/index.vue'
import PollView from '@/components/poll/PollView.vue'
import ReportDialog from '@/components/report-dialog/index.vue'
import { getToken } from '@/utils/cookieUtil'
import { mapState } from 'vuex'
import { getAuditBadge, isAuditPublished } from '@/constant'
export default {
  components: {
    Comment,
    ImgContent,
    PollView,
    ReportDialog
  },

  props: {
    articleId: [String, Number],
    commentId: [String, Number],
    // 由外层（移动端全屏弹窗）提供底部操作条时置 true：
    // 正文里的点赞/评论/收藏收起，避免同一屏出现两套一样的操作
    mobileToolbar: {
      type: Boolean,
      default: false
    }
  },
  mixins: [articleMixins],
  data () {
    return {
      article: {
        category: {},
        comments: [],
        tagList: [],
        userInfoVO: {
          nickName: '',
        },
      },
      fetchSuccess: false, // 标识当前请求是否结束
      style: '',
      serceShow: 0,
      moreMenuVisible: false,
      reportDialogVisible: false,
      isRecommend: false,
      isNotInterested: false
    }
  },

  computed: {
    ...mapState('commonStore', ['isCommentFlag']),
    auditBadge () {
      return getAuditBadge(this.article)
    },
    isPublished () {
      return isAuditPublished(this.article)
    }
  },
  created () {
    this.getArticleInfo()
  },

  watch: {
    isCommentFlag (newVal) {
      //插入需要在仓库数据变化时做的逻辑处理
      newVal && this.checkAfter()
    },
  },
  methods: {
    checkAfter () {
      this.style = ''
      this.serceShow = true
    },

    handleClike (id, path) {
      this.$router.push({ path: path, query: { id: id } })
    },

    formatDate: function (value, args) {
      var dt = new Date(value)
      let year = dt.getFullYear()
      let month = (dt.getMonth() + 1).toString().padStart(2, '0')
      let date = dt.getDate().toString().padStart(2, '0')
      if (args === "MM/dd") {
        return `${month}/${date}`
      }
      return `${year}-${month}-${date}`
    },

    // 获取文章详情
    getArticleInfo () {
      articleFetch.articleInfo(this.articleId).then(res => {
        this.article = res.data
        this.fetchSuccess = true
        this.serceShow = this.article.activeReadType

        // 触发事件，将文章数据传递给父组件
        this.$emit('article-loaded', res.data)

        // 获取偏好状态
        this.fetchPreferenceStatus()

        // 说明：正文是通过 {{ article.content }} 以纯文本渲染的（配图走 ImgContent），
        // 里面不会出现 img / h1~h6 / pre 节点。原先这里在 $nextTick 中扫描这些标签
        // 生成目录、绑图片预览、给代码块插「mac 三点」，全是空转；其中 getCodes 还用
        // document.querySelectorAll('pre') 全局取节点，在弹窗形态下会把弹窗外的 pre
        // 一并改掉。整块逻辑已移除。
      }).catch(err => {
        // 401未登录时，通知父组件关闭弹窗（登录框已由拦截器弹出）
        if (err.message === '__SILENT_AUTH__') {
          this.$emit('auth-failed')
          return
        }
        // 帖子不存在 / 已删除 / 仅作者可见等，交给父组件展示错误态
        this.$emit('load-error', err)
      })
    },
    // 外层底部操作条调用：聚焦主评论输入框并滚动到评论区
    focusComment () {
      if (this.toastIfUnpublished('该帖子当前不可评论')) return
      const comment = this.$refs.commentRef
      if (comment && comment.focusMainInput) {
        comment.focusMainInput()
        return
      }
      // 评论组件还没就绪时退化为滚动到评论区
      this.scrollToComment()
    },
    toastIfUnpublished (fallback) {
      if (this.isPublished) return false
      this.$toast.info(this.auditBadge ? this.auditBadge.tip : fallback)
      return true
    },
    like (article) {
      if (this.toastIfUnpublished('该帖子当前不可点赞')) return
      return articleMixins.methods.like.call(this, article)
    },
    handleCollect (article) {
      if (this.toastIfUnpublished('该帖子当前不可收藏')) return
      return articleMixins.methods.handleCollect.call(this, article)
    },
    scrollToComment () {
      const section = this.$refs.commentSection
      section && section.scrollIntoView({ behavior: 'smooth', block: 'start' })
    },
    // 处理评论新增事件
    handleCommentAdded () {
      this.article.commentCount = (this.article.commentCount || 0) + 1
      // 通知父组件文章数据已更新
      this.$emit('article-updated', this.article)
    },
    // 处理评论删除事件。count 是这次一共少了几条：删父评论时含整楼回复（服务端级联删除）
    handleCommentRemoved (count) {
      const removed = Number(count) || 1
      this.article.commentCount = Math.max(0, (Number(this.article.commentCount) || 0) - removed)
      this.$emit('article-updated', this.article)
    },
    // 点赞 / 收藏统一走 articleMixins（乐观更新 + 失败回滚 + 防连点），
    // 这里只通过 mixin 的回调把变化透出给父组件（移动端底部操作条、列表卡片同步）
    onArticleChange () {
      this.$emit('article-updated', this.article)
    },
    /**
     * 投票成功：写回投票数据并同步给列表卡片。
     *
     * 用 $set 而不是直接赋值 —— article 是接口返回的对象，
     * 没有投票的帖子上根本没有 poll 这个 key，直接赋值不会触发重渲染。
     * 走 $root 上现成的 article-data-sync 通道，卡片侧的 handleArticleSync 会按字段回填。
     */
    onPollVoted (poll) {
      if (!poll) return
      this.$set(this.article, 'poll', poll)
      this.$root.$emit('article-data-sync', { id: this.articleId, poll })
      this.$emit('article-updated', this.article)
    },
    // 检查登录状态
    checkLogin () {
      const token = getToken()
      if (!token) {
        this.$store.commit('systemStore/setLoginFlag', true)
        return false
      }
      return true
    },
    // 获取偏好状态
    async fetchPreferenceStatus () {
      if (!getToken()) return
      try {
        const res = await articleFetch.getPreferenceStatus({ articleId: this.articleId })
        if (res.data) {
          this.isRecommend = res.data.isRecommend || false
          this.isNotInterested = res.data.isNotInterested || false
        }
      } catch (e) {
        console.error('获取偏好状态失败:', e)
      }
    },
    // 推荐
    async handleRecommend () {
      if (!this.checkLogin()) return
      this.moreMenuVisible = false
      try {
        const res = await articleFetch.recommendArticle({ articleId: this.articleId })
        if (res.data) {
          this.isRecommend = res.data.isActive
          this.$toast.success(this.isRecommend ? '推荐成功' : '已取消推荐')
        }
      } catch (e) {
        this.$toast.error(e.message || '操作失败')
      }
    },
    // 不感兴趣
    async handleNotInterested () {
      if (!this.checkLogin()) return
      this.moreMenuVisible = false
      try {
        const res = await articleFetch.notInterestedArticle({ articleId: this.articleId })
        if (res.data) {
          this.isNotInterested = res.data.isActive
          this.$toast.success(this.isNotInterested ? '已标记为不感兴趣' : '已取消不感兴趣')
        }
      } catch (e) {
        this.$toast.error(e.message || '操作失败')
      }
    },
    // 举报
    handleReport () {
      if (!this.checkLogin()) return
      this.moreMenuVisible = false
      this.reportDialogVisible = true
    }
  },
}
</script>
<style lang="scss" scoped>
.article-wrapper {
  // padding: 10px;
  .read-duration {
    border-left: 5px solid #50bfff;
    background-color: var(--tips-backgroud-color);
    color: #bf5dd8;
    padding: 10px 0;
    margin-top: 15px;
    padding-left: 10px;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }
  .article {
    background-color: var(--background-color);
    padding: 20px;
    padding-top: 0;
    height: 100%;
    // margin-top: 80px;

    .category {
      border-radius: 3px;
      transition: transform 0.35s;
      height: 30px;
      line-height: 30px;

      &:hover {
        transform: translateY(-5px);
      }
    }
    .article-title {
      font-size: 18px;
      color: #333333;
      text-align: left;
      // padding-top: 20px;
      margin-bottom: 15px;
      word-break: break-word;
      // text-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
      font-weight: 700;
      svg {
        width: 50px;
        height: 50px;
        vertical-align: -10px;
      }
    }

    .item {
      display: flex;
      align-items: center;
      gap: 40px;
      line-height: 1;
      padding: 20px 0;

      // 右侧的「浏览量 + 更多操作」
      .item-extra {
        margin-left: auto;
        padding-right: 20px;
        display: inline-flex;
        align-items: center;
      }

      .textItem {
        display: inline-flex;
        align-items: center;
        cursor: pointer;
        transition: all 0.3s;
        color: #666;
        
        &:hover {
          transform: scale(1.05);
          color: #333;
        }
        
        svg {
          width: 18px;
          height: 18px;
          margin-right: 6px;
          flex-shrink: 0;
        }
        
        span {
          font-size: 14px;
          line-height: 1;
          color: inherit;
        }
      }
      
      .nickname {
        font-size: 14px;
        color: #666;
      }
      
      .more-btn {
        width: 28px;
        height: 28px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        cursor: pointer;
        transition: background-color 0.2s;
        margin-left: 12px;
        
        &:hover {
          background-color: #f5f5f5;
        }
        
        svg {
          width: 18px;
          height: 18px;
          color: #999;
        }
      }
    }
    .tips {
      border-left: 5px solid #50bfff;
      background-color: var(--tips-backgroud-color);
      color: #888;
      border-radius: 5px;
      padding: 10px;
      i {
        color: #50bfff;
        margin-right: 5px;
      }
    }
    .box-article {
      .warpper {
        background: var(--article-srect-background);
        position: relative;
        height: 210px;
        padding: 5px;
        &::before {
          content: "";
          position: absolute;
          top: -80px;
          left: 0;
          width: 100%;
          height: 80px;
          z-index: 2;
          background: linear-gradient(180deg, rgba(55, 55, 55, 0), #ccc);
        }
        .item-title {
          color: #fff;
        }
        .item-box {
          border-radius: 10px;
          background-color: var(--background-color);
          height: 150px;
          margin-left: 10px;
          margin-right: 10px;
          margin-top: 10px;
          margin-bottom: 10px;
          overflow: hidden;
          span {
            background: linear-gradient(135deg, #ff74cd 10%, #ec7d0b);
            border-top-left-radius: 10px;
            border-bottom-right-radius: 10px;
            padding: 5px;
            font-size: 0.9rem;
            color: #fff;
          }
          .neirong {
            text-align: center;
            margin-top: 15px;
            color: var(--text-color);
            font-size: 0.9rem;
          }
          .btn {
            margin: 0 auto;
            display: block;
            margin-top: 20px;
          }
        }
      }
    }
    .content {
      color: #333333;
      // line-height: 30px;
      line-height: 28px;
      // margin-top: 10px;
      margin-bottom: 16px;
      font-size: 16px;
      white-space: pre-wrap;
      word-break: break-word;
      overflow-wrap: break-word; // padding: 10px;
      .hljs-center {
        text-align: center;
      }
      blockquote {
        position: relative;
        padding: 0 10px;
        color: #6a737d;
        border-left: 0.25em solid #dfe2e5;
        margin: 20px 0;
      }
      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        margin: 10px 0;
      }
      table {
        background-color: var(--article-table-back-color);
        td {
          border: 1px solid var(--article-table-border-color);
          padding: 5px;
        }
        tr {
          background-color: var(--article-table-border-color);
          transition: all 0.3s ease-in-out;
          &:hover {
            background-color: var(--article-table-back-color);
            border: none;
          }
        }
        th {
          background-color: var(--article-table-back-color);
        }
      }
      p {
        a {
          text-decoration: none;
          color: #7bc549;
          &::after {
            content: "🔗";
          }
        }
      }
      code {
        vertical-align: middle;
        word-break: break-word !important;
        border-radius: 2px !important;
        overflow-x: auto !important;
        background-color: #fff5f5;
        color: #ff502c;
        font-size: 0.87em !important;
        padding: 0.065em 0.4em !important;
      }
      ol {
        margin-left: 20px;
      }
      pre {
        opacity: 1 !important;
        margin: 10px 0;
        color: #f8f8f2 !important;
        overflow: hidden;
        box-shadow: rgba(0, 0, 0, 0.55) 0px 2px 10px;
        border-radius: 8px;
        code {
          line-height: 20px !important;
          font-size: 16px !important;
          vertical-align: top;
          padding: 10px !important;
          border-bottom-left-radius: 8px !important;
          border-bottom-right-radius: 8px !important;
          background-color: #303133 !important;
          color: #c0c4cc !important;
          width: -webkit-fill-available;
          display: inline-block;
        }
      }
      img {
        max-width: 100%;
        margin: 15px 0;
        border-radius: 5px !important;
        transition: box-shadow 0.35s, transform 0.35s;
        cursor: pointer;
        max-height: 500px;
        &:hover {
          box-shadow: 5px 10px 5px rgba(0, 0, 0, 0.2);
          transform: translateY(-10px);
        }
      }
      ul {
        margin-left: 20px;
      }
    }
    
    .publish-location {
      font-size: 12px;
      color: #999;
      margin-top: 12px;
    }

    .audit-banner {
      margin-top: 12px;
      padding: 8px 12px;
      border-radius: 6px;
      font-size: 13px;
      line-height: 1.5;

      &--auditing {
        color: #e6a23c;
        background: rgba(230, 162, 60, 0.1);
      }

      &--rejected {
        color: #f56c6c;
        background: rgba(245, 108, 108, 0.1);
      }
    }
    
    .tag-share {
      display: flex;
      margin-right: 5px;
      align-items: center;
      position: relative;
      // border-bottom: 1px solid var(--border-line);
      // margin-top: 20px;
      justify-content: space-between;
      .tagBtn {
        margin-right: 5px;
        background-color: var(--article-share-color);
        border: 1px solid var(--article-share-color);
        padding: 3px 5px;
        border-radius: 25px;
        display: inline-block;
        color: var(--text-color);
        i {
          color: var(--theme-color);
        }
      }
      .social-share {
        position: relative;
        border-top-left-radius: 25px;
        border-bottom-left-radius: 25px;
        height: 100%;
        display: flex;
        align-items: center;
        &:hover .share {
          transform: rotate(360deg);
        }
        .share-item {
          text-align: left !important;
          width: auto;
          display: none;
          margin-right: 15px;
          transition: display 0.3s ease-in-out;
        }
        .share {
          display: inline-block;
          font-size: 18px;
          width: 100%;
          height: 100%;
          font-weight: 700;
          text-align: center;
          color: #fff;
          background: #99f;
          border-radius: 50%;
          transition: all 0.3s;
        }
        .social-share-icon {
          margin-left: 10px;
          display: inline-block;
          width: 30px;
          height: 30px;
          font-size: 20px;
          border-radius: 50%;
          line-height: 30px;
          border: 1px solid #666;
          color: #666;
          text-align: center;
          vertical-align: middle;
          text-decoration: none;
          i {
            font-size: 25px;
          }
        }
        .icon-qzone {
          border-color: #fdbe3d;
          color: #fdbe3d;
          &:hover {
            background-color: #fdbe3d;
            i {
              color: white;
            }
          }
        }
        .icon-wechat {
          color: #7bc549 !important;
          border-color: #7bc549;
          &:hover {
            background-color: #7bc549;
            i {
              color: white;
            }
          }
        }
        .icon-weibo {
          color: #ff763b !important;
          border-color: #ff763b;
          &:hover {
            background-color: #ff763b;
            i {
              color: white;
            }
          }
        }
        .icon-qq {
          color: #56b6e7 !important;
          border-color: #56b6e7;
          &:hover {
            background-color: #56b6e7;

            i {
              color: white;
            }
          }
        }
      }
    }
    .wechatImg {
      img {
        width: 100%;
      }
    }
    .copyright {
      background-color: var(--text-color3);
      border-radius: 5px;
      width: 100%;
      min-height: 130px;
      position: relative;
      border: 1px dashed var(--theme-color);
      margin-top: 20px;
      &::before {
        content: "声明";
        background-image: linear-gradient(to right, #ffcc99, #ff99cc);
        width: 30%;
        padding: 5px;
        border-radius: 999px;
        position: absolute;
        top: -18px;
        left: 35%;
        text-align: center;
        border: 1px dashed var(--theme-color);
        font-weight: 700;
      }
      .copyrightItem {
        padding: 10px 10px;
        height: 100%;
        line-height: 26px;
        svg {
          width: 18px;
          height: 18px;
          margin-right: 3px;
          vertical-align: -4px;
        }
        .text {
          color: #909399;
          font-size: 14px;
          // margin-left: 8px;
          text-decoration: none;
        }
        .name {
          color: var(--theme-color);
          font-weight: 700;
        }
        a:hover {
          color: var(--theme-color);
        }
      }
      .yuan {
        width: 20px;
        height: 20px;
        position: absolute;
        top: 10px;
        right: 10px;
      }
    }
    .comment-main {
      // margin-top: 30px;
      padding-top: 20px;
      
      .comment-divider {
        width: 100%;
        height: 0.5px;
        background-color: #f5f5f5;
        margin-bottom: 20px;
      }
      
      .title {
        font-weight: 700;
        font-size: 20px;
        // margin-top: 20px;
        color: var(--article-color);
        svg {
          width: 20px;
          height: 20px;
        }

        .title-tip {
          color: var(--text-color);
          font-size: 0.8rem;
          font-weight: 400;
        }
      }
    }
  }
}
.wxImg {
  display: block;
  margin: 0 auto;
  width: 50%;
  height: 50%;
  margin-bottom: 15px;
}

// 手机端文章详情内容适配
@media screen and (max-width: 767px) {
  .article-wrapper .article {
    padding: 14px 14px 16px !important;

    .article-title {
      font-size: 19px !important;
      line-height: 27px !important;
      margin-bottom: 10px !important;
    }

    .content {
      // 手机上阅读距离更近，正文比桌面略小、行高更宽松
      font-size: 16px !important;
      line-height: 27px !important;
      margin-bottom: 12px !important;
    }

    // 元信息行：浏览量 + 更多操作，靠左排，去掉桌面端的右侧留白
    .item {
      gap: 16px !important;
      padding: 10px 0 14px !important;
      flex-wrap: wrap;
      border-bottom: 0.5px solid #f2f2f2;

      .textItem {
        svg {
          width: 16px !important;
          height: 16px !important;
        }
        span {
          font-size: 13px !important;
        }
      }

      .item-extra {
        padding-right: 0 !important;
        font-size: 13px;
      }

      .nickname {
        font-size: 13px !important;
      }
    }

    ::v-deep(.content) {
      img {
        max-width: 100% !important;
        height: auto !important;
        margin: 8px 0 !important;
        border-radius: 8px !important;

        &:hover {
          transform: none !important;
          box-shadow: none !important;
        }
      }

      pre code {
        font-size: 13px !important;
        line-height: 18px !important;
      }
    }

    .publish-location {
      margin-top: 8px !important;
    }

    .tag-share {
      flex-direction: column;
      align-items: flex-start;
      gap: 6px;
      margin-top: 12px !important;
    }

    .comment-main {
      padding-top: 14px !important;

      .comment-divider {
        display: none;
      }

      .title {
        font-size: 16px !important;

        .title-tip {
          display: none;
        }
      }
    }
  }

  // 底部操作条接管了点赞/评论/收藏后，元信息行只剩「浏览量 + 更多」，靠左排更自然
  .article-wrapper.has-mobile-toolbar .article .item .item-extra {
    margin-left: 0 !important;
  }
}
</style>

<style>
.hljs {
  border-bottom-left-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
}
.mac-icon {
  height: 15px !important;
  display: flex;
  align-items: center;
  border: 1px solid #272822 !important;
  background-color: #272822 !important;
  padding: 8px !important;
  border-top-left-radius: 8px !important;
  border-top-right-radius: 8px !important;
}
.mac-icon > span {
  display: inline-block !important;
  letter-spacing: 5px !important;
  word-spacing: 5px !important;
  width: 10px !important;
  height: 10px !important;
  border-radius: 8px !important;
}
.mac-icon-red {
  background-color: red !important;
}
.mac-icon-yellow {
  margin-left: 10px;
  background-color: yellow !important;
}
.mac-icon-green {
  margin-left: 10px;
  background-color: green !important;
}
.mac-icon-lang {
  width: 50px !important;
  padding-left: 10px !important;
  font-size: 16px !important;
  vertical-align: top !important;
}
.copy-button {
  border-radius: 3px;
  padding: 5px !important;
  color: #ffffff !important;
  font-size: 1rem;
  margin-left: auto;
}
.copy-button:hover {
  background-color: black !important;
}
.line-num-box {
  display: inline-block !important;
  color: #ccc !important;
  border-right: 2px solid #fff !important;
  line-height: 20px !important;
  font-size: 16px !important;
  text-align: right !important;
  padding-left: 10px !important;
  padding-right: 10px !important;
}

.more-actions-popover {
  padding: 4px 0 !important;
  min-width: 150px !important;
  border-radius: 8px !important;
}
.more-actions-popover .more-menu-item {
  display: flex;
  align-items: center;
  padding: 8px 14px;
  cursor: pointer;
  font-size: 13px;
  color: #4a4a4a;
  transition: all 0.2s;
  line-height: 1;
}
.more-actions-popover .more-menu-item:hover {
  background-color: #f5f7fa;
}
.more-actions-popover .more-menu-item.active {
  color: #409eff;
}
.more-actions-popover .more-menu-item.danger {
  color: #f56c6c;
}
.more-actions-popover .more-menu-item .menu-svg {
  width: 14px;
  height: 14px;
  margin-right: 6px;
  flex-shrink: 0;
}
.more-actions-popover .more-menu-item .menu-i {
  font-size: 14px;
  margin-right: 6px;
  flex-shrink: 0;
}
</style>